export default {
  // タブ
  tabDisable: 'QRコード無効化',
  tabPageConfig: '無効化ページ設定',
  // 操作バー
  addDisable: '無効化を追加',
  // 検索
  batchCode: 'バッチコード',
  batchCodePlaceholder: 'バッチコードを入力してください',
  qrcode: 'QRコード',
  qrcodePlaceholder: 'QRコードを入力してください',
  disableTime: '無効化時間',
  startTime: '開始時間',
  endTime: '終了時間',
  to: '～',
  // テーブル列
  colBatchSn: 'バッチ',
  colQrcodeRange: 'QRコード範囲',
  colQrcodeCount: 'QRコード数量',
  colForbidMessage: '無効化理由',
  colCreatedAt: '無効化時間',
  colAction: '操作',
  // 操作
  releaseDisable: '解除',
  edit: '編集',
  // 解除確認
  confirmReleaseTitle: '解除の確認',
  confirmReleaseContent: 'このコードの無効化状態を解除しますか？',
  // 追加/編集モーダル
  addDisableTitle: '無効化を追加',
  editDisableTitle: '無効化を編集',
  batchCodeRequired: 'バッチを選択してください',
  batchSn: 'バッチ',
  batchSnPlaceholder: 'QRコードバッチを選択',
  forbidType: '無効化タイプ',
  forbidTypeAll: '全バッチ無効化',
  forbidTypePartial: '部分無効化',
  startCode: '開始コード',
  startCodePlaceholder: '開始コードを入力してください',
  startCodeRequired: '開始コードを入力してください',
  endCode: '終了コード',
  endCodePlaceholder: '終了コードを入力してください',
  endCodeRequired: '終了コードを入力してください',
  smallSerialStart: '小シリアル開始',
  smallSerialStartPlaceholder: '小シリアル開始値を入力してください',
  smallSerialEnd: '小シリアル終了',
  smallSerialEndPlaceholder: '小シリアル終了値を入力してください',
  forbidMessage: '無効化メッセージ',
  forbidMessagePlaceholder: '無効化メッセージを入力してください',
  forbidMessageRequired: '無効化メッセージを入力してください',
  remark: '備考',
  remarkPlaceholder: '備考を入力してください',
  // 空状態
  emptyText: '無効化記録がありません',
  // 無効化ページ設定
  pageTitle: 'ページタイトル',
  pageTitleRequired: '少なくとも1つの言語のタイトルを入力してください',
  tipImage: 'ヒント画像',
  textColor: 'テキスト色',
  bgColor: '背景色',
  resetDefaultImage: 'デフォルト画像に戻す',
  resetDefaultColor: 'デフォルト色に戻す',
  defaultPreviewTitle: 'QRコード異常',
  defaultTipImage: '無効化画像',
  defaultTipText: 'このQRコードは無効化されています。サポートにお問い合わせください。',
};
